import './card.scss'

import classNames from 'classnames'
import { Link } from 'gatsby'
import _ from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'

import getCategory from '@/helpers/get-category'
import { getPostSubCategories } from '@/helpers/get-subcategory'
import { useCategories } from '@/hooks/useCategories'
import { withTrans } from '@/i18n/withTrans'

import EventDetail from '../card-event-detail/card-event-detail'
import DynamicImage from '../dynamic-image/dynamic-image'
import SearchTag from '../tag/search-tag'
import { CardCategoryLink } from './card-category-link'

const getDuration = (item) => {
  return _.get(item, 'acf.readingDuration')
}

const validUri = (item) => {
  return (item?.uri ?? '').replaceAll('%', '-')
}

const isEvent = (item) => {
  const isEventInCategories = _.head(
    _.filter(_.get(item, 'categories.nodes'), (c) => c.slug.startsWith('event'))
  )
  return !_.isEmpty(isEventInCategories)
}

const Card = ({
  item,
  minicard = false,
  hasNoImage = false,
  hasUnderline,
  hasNoLocationDisplay = false,
  hasDate = true,
  i18n,
  isSearch = false,
  isCarousel = false,
  className = '',
  onClick,
  type,
}) => {
  const [mainCategory, setMainCategory] = useState({})
  const isevent = useMemo(() => isEvent(item), [item])
  const { withSubCategories } = useCategories()

  const classMore = classNames({
    'card-more': true,
    'card-more-minicard': minicard,
  })
  const classCardContainer = classNames({
    'card-container': true,
    'minicard-container': minicard,
    underline: hasUnderline,
  })
  const classContentMinicard = classNames({
    'card-summary': true,
    'minicard-card-summary': minicard,
  })

  const categoriesInObj = _.get(item, 'categories.nodes')

  const subcategory = getPostSubCategories(item)
  const duration = getDuration(item)

  useEffect(() => {
    const headCategory = getCategory(withSubCategories, categoriesInObj)
    setMainCategory(headCategory)
  }, [withSubCategories, categoriesInObj])

  if (_.isEmpty(item)) return null

  return (
    <div className={`${classCardContainer} ${className}`}>
      <div className="card-frame">
        {!hasNoImage && (
          <Link className="card-box-image" to={validUri(item)}>
            <DynamicImage item={item} />
          </Link>
        )}
        <div className="card-content">
          <div>
            <CardCategoryLink
              mainCategory={mainCategory}
              subCategory={subcategory}
              minicard={minicard}
              date={_.get(item, 'date')}
              i18n={i18n}
              onClick={onClick}
              type={type}
            />
            <Link to={validUri(item)}>
              <h2 className="card-title">{_.get(item, 'title', '')}</h2>
            </Link>

            {!isCarousel && (
              <div className={classContentMinicard}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: _.get(item, 'excerpt', ''),
                  }}
                />
              </div>
            )}
            {isSearch && (
              <SearchTag categoriesInObj={_.get(item, 'categories.nodes')} />
            )}
            {!isCarousel && !minicard && (
              <p className={classMore}>
                <Link to={validUri(item)}>
                  Read More{' '}
                  {duration !== null &&
                    `- (${duration} ${duration > 1 ? 'minutes' : 'minute'})`}
                </Link>
              </p>
            )}
          </div>
          <div>
            {!isCarousel && minicard && (
              <p className={classMore}>
                <Link to={validUri(item)}>
                  Read More{' '}
                  {duration !== null &&
                    `- (${duration} ${duration > 1 ? 'minutes' : 'minute'})`}
                </Link>
              </p>
            )}
            {isevent && hasDate && (
              <EventDetail
                article={item}
                hasNoLocationDisplay={hasNoLocationDisplay}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTrans(Card)
